import React from 'react';
import 'objectFitPolyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'objectFitPolyfill';

import loadable from '@loadable/component';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles.css';
import Cookies from './utils/cookies';

loadable.lib(() => import('react-app-polyfill/ie9'));
loadable.lib(() => import('react-app-polyfill/stable'));
const Sentry = loadable.lib(() => import('@sentry/react'));
const Tracing = loadable.lib(() => import('@sentry/tracing'));

(async () => {
  const { init } = await Sentry.load();
  const { Integrations } = await Tracing.load();

  if (process.env.NODE_ENV === 'production') {
    init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new Integrations.BrowserTracing()],
      environment: process.env.REACT_APP_BUILD_TYPE,
      tracesSampleRate: process.env.REACT_APP_BUILD_TYPE === 'stage' ? 1.0 : 0.25,
    });
  }
})();

const hasAuthenticatedCookie = Cookies.get('auth0.is.authenticated') === 'true';

ReactDOM.render(
  <App
    type="client"
    client={undefined}
    context={undefined}
    location={undefined}
    host={window?.location?.hostname}
    hasAuthenticatedCookie={hasAuthenticatedCookie}
  />,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
